<template>
  <div>
    <ConsolidationUsersHead
            :countFilterParams="countFilterParams"
            :showFilter="showFilter"
            @toggleFilter="toggleFilter"
            @filter="$emit('filter')"
            @reload="$emit('reload')"
    />

    <div class="table-filter-wrap">
      <ConsolidationUsersFilter
              :showFilter="showFilter"
              :filterGetParams="filterGetParams"
              @close="closeFilter"
              @changeFilter="data => $emit('changeFilter', data)"
              @resetFilter="$emit('resetFilter')"
      />

      <ConsolidationUsersTable
              @showMore="$emit('showMore')"
              @resetFilter="$emit('resetFilter')"
              @updateTable="$emit('updateTable')"
              @reload="$emit('reload')"
      />
    </div>
  </div>
</template>

<script>


  import ConsolidationUsersHead from "./ConsolidationUsersHead/ConsolidationUsersHead";
  import ConsolidationUsersFilter from "./ConsolidationUsersFilter/ConsolidationUsersFilter";
  import ConsolidationUsersTable from "./ConsolidationUsersTable/ConsolidationUsersTable";

  export default {
    name: "ConsolidationUsersTableAdmin",

    components: {
      ConsolidationUsersHead,
      ConsolidationUsersFilter,
      ConsolidationUsersTable,
    },

    props: {
      countFilterParams: Number,
      filterGetParams: Object,
    },

    data(){
      return{
        showFilter: false,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },
    }
  }
</script>

<style scoped>

</style>
